<template>
    <div>
        <div>
            <v-container align> 
                
                <v-alert v-if="alert" type="error">
                    {{ $t('error_pi_or_problem_not_selected') }}
                </v-alert>

                <v-row>

                    <v-col >
                        <v-card>
                            <p class="pt-4 pl-4 pr-4"> {{ $t("type_of_pi") }} </p>

                            <v-select
                                :items="pi_models"
                                v-model="pi"
                                class="pb-4 pl-4 pr-4"
                            >

                                <template slot="item" slot-scope="pi"> 
                                    {{$t(pi.item.name)}}
                                </template>

                                <template slot="selection" slot-scope="pi">
                                    {{$t(pi.item.name)}}
                                </template>

                            </v-select>
                        </v-card>
                    </v-col>

                    <v-col>
                        <v-card>
                            <p class="pt-4 pl-4 pr-4"> {{ $t('select_problem') }} </p>

                            <v-select
                                :items="problems"
                                v-model="estimated_problem"
                                class="pb-4 pl-4 pr-4"
                            >
                                <template slot="item" slot-scope="estimated_problem"> 
                                    {{ $t(estimated_problem.item.name) }}
                                </template>

                                <template slot="selection" slot-scope="estimated_problem">
                                    {{ $t(estimated_problem.item.name) }}
                                </template>
                            </v-select>
                        </v-card>
                    </v-col>
                </v-row>

            </v-container>
        </div>
        <div>
            <v-container>
                <v-row>
                    <v-col cols="12" @click="return_keywords()">
                        <v-card class="rounded-pill pt-2" color="#106B9E" dark height="40" align="center" hover> {{ $t('starting_screen_button') }} </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>

    </div>
    
</template>

<script>
    import i18n from '../i18n'
    export default {
        name: 'startingEvaluation',
        data: () => ({
            pi: null,
            estimated_problem: null,
            alert: false,
            keywords: [],

            pi_models: [
                {name: 'not_sure', keywords: ['no_pwr_led'] },
                {name: 'pi_zero', keywords: ['no_pwr_led'] },
                {name: 'pi_zero_w', keywords: ['no_pwr_led'] },
                {name: 'pi_zero_2_w', keywords: ['no_pwr_led'] },
                {name: 'pi_a+', keywords: ['pwr_led', 'good_pwr_led'] },
                {name: 'pi_a', keywords: ['pwr_led', 'bad_pwr_led'] },
                {name: 'pi_b+', keywords: ['pwr_led', 'good_pwr_led'] },
                {name: 'pi_b', keywords: ['pwr_led', 'bad_pwr_led'] },
                {name: 'pi_2_b', keywords: ['pwr_led', 'good_pwr_led'] },
                {name: 'pi_3_b', keywords: ['pwr_led', 'good_pwr_led'] },
                {name: 'pi_3_b+', keywords: ['pwr_led', 'good_pwr_led'] },
                {name: 'pi_3_a+', keywords: ['pwr_led', 'good_pwr_led'] },
                {name: 'pi_4_b', keywords: ['pwr_led', 'good_pwr_led'] },
                {name: 'pi_400', keywords: ['pwr_led', 'good_pwr_led'] },
            ],

            problems: [
                {name: 'pi_not_starting', keywords: ['estimated_pwr']},
                {name: 'no_screen_output', keywords: ['video', 'no_output']},
                {name: 'pi_random_restart', keywords: ['random_reboot', 'maybe_pwr', 'maybe_little_power', 'maybe_no_power']},
                {name: 'usb_not_working', keywords: ['usb_not_working']},
                {name: 'no_internet_connection', keywords: ['estimated_internet']},
                {name: 'bad_screen_output', keywords: ['video', 'inconsistent_output']} 
            ]

        }),
        methods: {
            return_keywords() {
                if (this.pi !== null && this.estimated_problem !== null) {
                    for (let i = 0; i < this.pi.keywords.length; i++) {
                    this.keywords.push(this.pi.keywords[i])
                    }
                    for (let i = 0; i < this.estimated_problem.keywords.length; i++) {
                        this.keywords.push(this.estimated_problem.keywords[i])
                    }
                    this.alert = false
                    this.$emit('starting_keywords', [this.keywords, []])
                }
                else {
                    this.alert = true
                }
            },
        }
    }

</script>
